import { getRecommendations, postRecommendation, putRecommendation } from '../../../Api/services/backoffice';

export const key = 'recommendation';

const entityName = {
  singular: 'Recomendação',
  plural: 'Recomendações',
};

const queries = {
  list: { key, fn: getRecommendations },
  detail: { key },
};

const mutations = {
  create: postRecommendation,
  update: putRecommendation,
};

const fields = {
  table: [
    { key: 'focus', label: 'Foco' },
    { key: 'mc', label: 'MC' },
    { key: 'mcContr', label: 'MC Contratada' },
    { key: 'mcFat', label: 'MC Faturada' },
    { key: 'recommend', label: 'Recomendação' },
    { key: 'message', label: 'Mensagem' },
  ],
};

export const listConfig = {
  title: entityName.plural,
  tableFields: fields.table,
  searchFields: fields.search,
  queryConfig: queries.list,
};

export const createConfig = {
  entityName: entityName.singular,
  mutationFn: mutations.create,
};

export const updateConfig = {
  entityName: entityName.singular,
  mutationFn: mutations.update,
  queryConfig: queries.detail,
};
